module.exports = __webpack_public_path__ + "img/service4.0469d8ee.png";